import React, { ChangeEventHandler, FormEventHandler } from 'react';
import { useStyles } from './styles';
import { useEditFormContext } from '../context';
import { Button, Grid, MenuItem, Select, Typography } from '@material-ui/core';
import { WrappedTextfield } from 'components/Inputs/WrappedTextField';

export const AddQuestion = () => {
  const {
    newQuestionTitle,
    setNewQuestionTitle,
    newQuestionType,
    setNewQuestionType,
    questionTypes,
    handleNewQuestion
  } = useEditFormContext();
  const styles = useStyles();

  const handleChangeNewQuestionTitle: ChangeEventHandler<HTMLInputElement> = (event) =>
    setNewQuestionTitle(event.target.value);

  const handleChangeNewQuestionType: ChangeEventHandler<{ name?: string; value: unknown }> = (event) => {
    const selectedValue = `${event.target.value}`;

    const selectedTypeValue = questionTypes.find(({ value }) => selectedValue === value);

    setNewQuestionType(selectedTypeValue || null);
  };

  const handleSubmit: FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    event.stopPropagation();
    handleNewQuestion();
  };

  return (
    <form onSubmit={handleSubmit}>
      <Typography className={styles.sectionTitle}>Questões</Typography>
      <Grid container spacing={1}>
        <Grid item xs={6} md={7}>
          <WrappedTextfield
            charLimit={100}
            label="Questão"
            variant="outlined"
            value={newQuestionTitle}
            className={styles.input}
            onChange={handleChangeNewQuestionTitle}
          />
        </Grid>
        <Grid item xs={6} md={3}>
          <Select
            value={(newQuestionType || questionTypes[0])?.value || ''}
            variant="outlined"
            className={styles.selectInput}
            onChange={handleChangeNewQuestionType}
          >
            {questionTypes.map(({ label, value }, index) => (
              <MenuItem value={value} key={index}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item>
          <Button className={styles.buttonApply} type="submit" variant="contained" color="secondary">
            Adicionar
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};
